import React from "react";
import {
  Box,
  Button,
  Typography,
  Paper
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LogoutIcon from "@mui/icons-material/Logout";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";


function BusinessApps({ onLogout }) {
  const navigate = useNavigate();

  const user = JSON.parse(
    sessionStorage.getItem("cadence_user") || "{}"
  );

  const handleLogout = () => {
    sessionStorage.removeItem("usertoken");
    sessionStorage.removeItem("cadence_user");
    sessionStorage.removeItem("cadence_workspace_id");
    sessionStorage.removeItem("cadence_api_base");

    if (onLogout) onLogout();

    navigate("/businessuserlogin", {
      replace: true
    });
  };

  return (
    <Box sx={{
      minHeight: "100vh",
      background: "#f3f7fb",
      p: 5
    }}>
        <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>
      <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <Typography sx={{
          fontSize: 22,
          fontWeight: 700,
          color: "#0078c9"
        }}>
          SelexSuite Project & Business Applications
        </Typography>

       
      </Box>

      <Typography sx={{
        fontSize: 16,
        mt: 5,
        mb: 4
      }}>
        Welcome, {user.full_name || user.username}
      </Typography>

      <Box sx={{
        display: "flex",
        gap: 3,
        flexWrap: "wrap"
      }}>
        {[
          {
            title: "CADENCE",
            description: "Projects & Business Development",
            path: "/cadence",
            icon: <DashboardIcon sx={{ fontSize: 36 }} />
          },
          {
            title: "SelexPlanner",
            description: "Project Planning & Scheduling",
            path: "/selexplanner",
            icon: <CalendarMonthIcon sx={{ fontSize: 36 }} />
          }
        ].map((app) => (
          <Paper
            key={app.title}
            sx={{
              p: 4,
              width: 280,
              borderRadius: 3,
              textAlign: "center"
            }}
          >
            <Box sx={{ color: "#0078c9" }}>
              {app.icon}
            </Box>

            <Typography sx={{
              fontSize: 18,
              fontWeight: 700,
              mt: 2
            }}>
              {app.title}
            </Typography>

            <Typography sx={{
              fontSize: 12,
              color: "#64748b",
              my: 2
            }}>
              {app.description}
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate(app.path)}
              sx={{
                background: "#0078c9",
                textTransform: "none",
                fontSize:12,
              }}
            >
              Open Application
            </Button>
          </Paper>
        ))}
      </Box>
    </Box>
  );
}

export default BusinessApps;